import React from 'react';

interface Props
{
  leftAddon?: React.ReactNode,
  rightAddon?: React.ReactNode,
}

export const WithAddon: React.FC<Props> = ({leftAddon, rightAddon, children}) =>
{
  const WithoutAddon = (target: React.ReactNode) => target;
  const withAddon = (target: React.ReactNode, addon: React.ReactNode, type: string) =>
    <div className={`with-addon-${type}`}>
      <div className='addon'>{addon}</div>
      {target}
    </div>;

  const withLeftAddon = leftAddon ? (x: React.ReactNode) => withAddon(x, leftAddon, 'left') : WithoutAddon;
  const withRightAddon = rightAddon ? (x: React.ReactNode) => withAddon(x, rightAddon, 'right') : WithoutAddon;

  return <>{withLeftAddon(withRightAddon(children))}</>;
}